if (!customElements.get('mtt-pack')) {
  customElements.define('mtt-pack', class MttPack extends HTMLElement {
    connectedCallback() {
      this.maxTes = parseInt(this.dataset.maxTes, 10) || 3;
      this.pct = parseInt(this.dataset.pct, 10) || 25;
      this.tes = new Map();
      this.accesorio = null;
      var primerBoton = this.querySelector('[data-pagar]');
      this.etiquetaPagar = primerBoton ? primerBoton.textContent : 'Ir a pagar';
      this.escuchar();
      var self = this;
      this.querySelectorAll('[data-accesorio] [data-variantes]').forEach(function (sel) {
        self.sincronizarVariante(sel.closest('[data-accesorio]'));
      });
      this.pintar();
      this.vigilarPantalla();

      // Al volver atras desde el checkout la pagina sale de la cache con los
      // botones a medio camino: los dejamos como estaban.
      var self = this;
      window.addEventListener('pageshow', function () { self.restaurarBotones(); });
      this.querySelectorAll('[data-carro]').forEach(function (carro) {
        carro.addEventListener('scroll', function () { self.sincronizarFlechas(); }, { passive: true });
      });
      window.addEventListener('resize', function () { self.sincronizarFlechas(); });
      this.sincronizarFlechas();
    }

    restaurarBotones() {
      var self = this;
      this.querySelectorAll('[data-pagar]').forEach(function (b) { b.textContent = self.etiquetaPagar; });
      this.pintar();
    }

    // La barra fija solo aparece mientras la seccion esta a la vista
    vigilarPantalla() {
      var seccion = this.closest('section');
      if (!seccion || typeof IntersectionObserver === 'undefined') return;
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          document.body.classList.toggle('mtt-pack-cerca', e.isIntersecting);
        });
      }, { rootMargin: '-10% 0px -10% 0px' }).observe(seccion);
    }

    // Formato de moneda del propio tema, para no inventar uno distinto
    plata(centavos) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(centavos, window.moneyFormat);
      }
      return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
    }

    totalTes() {
      var suma = 0;
      this.tes.forEach(function (t) { suma += t.cantidad; });
      return suma;
    }

    escuchar() {
      var self = this;
      this.addEventListener('click', function (e) {
        var cab = e.target.closest('[data-cab]');
        if (cab) {
          var pasoCab = cab.closest('[data-paso]');
          if (pasoCab.hasAttribute('data-bloqueado')) return;
          var abierto = cab.getAttribute('aria-expanded') === 'true';
          self.abrir(abierto ? 0 : parseInt(pasoCab.dataset.paso, 10));
          return;
        }
        var mas = e.target.closest('[data-mas]');
        var menos = e.target.closest('[data-menos]');
        if (mas || menos) {
          var tarjetaTe = e.target.closest('[data-te]');
          if (tarjetaTe) self.cambiarTe(tarjetaTe, mas ? 1 : -1);
          return;
        }
        var elegir = e.target.closest('[data-elegir]');
        if (elegir) {
          var tarjetaAcc = e.target.closest('[data-accesorio]');
          if (tarjetaAcc) self.elegirAccesorio(tarjetaAcc);
          return;
        }
        var flecha = e.target.closest('[data-flecha]');
        if (flecha) { self.desplazar(flecha); return; }
        var pagar = e.target.closest('[data-pagar]');
        if (pagar && !pagar.disabled) self.pagar(pagar);
      });
      // Cambiar la opcion habilita el boton y actualiza el precio mostrado
      this.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-variantes]');
        if (!sel) return;
        self.sincronizarVariante(sel.closest('[data-accesorio]'));
      });
    }

    sincronizarVariante(tarjeta) {
      var sel = tarjeta.querySelector('[data-variantes]');
      if (!sel) return;
      var boton = tarjeta.querySelector('[data-elegir]');
      if (!sel.value) {
        boton.disabled = true;
        if (this.accesorio && this.accesorio.tarjeta === tarjeta) {
          this.accesorio = null;
          this.pintar();
        }
        return;
      }
      var opcion = sel.options[sel.selectedIndex];
      boton.disabled = false;
      tarjeta.dataset.variant = sel.value;
      tarjeta.dataset.precio = opcion.dataset.precio;
      tarjeta.querySelector('.mtt-pick-precio').textContent = this.plata(parseInt(opcion.dataset.precio, 10));
      if (this.accesorio && this.accesorio.tarjeta === tarjeta) this.elegirAccesorio(tarjeta, true);
    }

    elegirAccesorio(tarjeta, forzar) {
      var sel = tarjeta.querySelector('[data-variantes]');
      if (sel && !sel.value) return;
      var mismo = this.accesorio && this.accesorio.tarjeta === tarjeta;
      if (mismo && !forzar) {
        this.accesorio = null;
      } else {
        this.accesorio = {
          tarjeta: tarjeta,
          variante: tarjeta.dataset.variant,
          nombre: tarjeta.dataset.nombre,
          precio: parseInt(tarjeta.dataset.precio, 10) || 0,
          img: tarjeta.dataset.img
        };
      }
      this.pintar();
      this.avanzar();
    }

    abrir(numero) {
      var self = this;
      [1, 2, 3].forEach(function (n) {
        var paso = self.querySelector('[data-paso="' + n + '"]');
        if (!paso) return;
        var abierto = n === numero;
        paso.querySelector('[data-cab]').setAttribute('aria-expanded', String(abierto));
        paso.querySelector('[data-cuerpo]').hidden = !abierto;
      });
      var cab = this.querySelector('[data-paso="' + numero + '"] [data-cab]');
      if (cab) cab.focus();
      this.sincronizarFlechas();
    }

    bloqueos() {
      var completo1 = this.totalTes() >= this.maxTes;
      var completo2 = !!this.accesorio;
      this.marcarBloqueo(this.querySelector('[data-paso="2"]'), !completo1);
      this.marcarBloqueo(this.querySelector('[data-paso="3"]'), !(completo1 && completo2));
    }

    marcarBloqueo(paso, bloqueado) {
      if (!paso) return;
      var cab = paso.querySelector('[data-cab]');
      if (bloqueado) {
        paso.setAttribute('data-bloqueado', '');
        cab.setAttribute('tabindex', '-1');
        cab.setAttribute('aria-disabled', 'true');
        cab.setAttribute('aria-expanded', 'false');
        paso.querySelector('[data-cuerpo]').hidden = true;
      } else {
        paso.removeAttribute('data-bloqueado');
        cab.removeAttribute('tabindex');
        cab.removeAttribute('aria-disabled');
      }
    }

    // Al completar un paso, se pliega y se abre el siguiente
    avanzar() {
      var self = this;
      var listoTes = this.totalTes() >= this.maxTes;
      if (!listoTes) return;
      var siguiente = this.accesorio ? 3 : 2;
      var paso = this.querySelector('[data-paso="' + siguiente + '"]');
      if (paso && paso.querySelector('[data-cuerpo]').hidden) {
        setTimeout(function () { self.abrir(siguiente); }, 260);
      }
    }

    // Las lineas del pack: primero los tres tes, despues el cuarto producto
    lineas() {
      var salida = [];
      this.tes.forEach(function (t, id) {
        salida.push({ variante: id, nombre: t.nombre, cantidad: t.cantidad, precio: t.precio, img: t.img, paso: 1 });
      });
      if (this.accesorio) {
        salida.push({
          variante: this.accesorio.variante, nombre: this.accesorio.nombre, cantidad: 1,
          precio: this.accesorio.precio, img: this.accesorio.img, paso: 2
        });
      }
      return salida;
    }

    totalCentavos() {
      return this.lineas().reduce(function (suma, l) { return suma + l.precio * l.cantidad; }, 0);
    }

    pintarResumen() {
      var self = this;
      var lista = this.querySelector('[data-lineas]');
      if (lista) {
        lista.innerHTML = '';
        this.lineas().forEach(function (l) {
          var li = document.createElement('li');
          li.className = 'mtt-linea';
          var img = document.createElement('img');
          img.src = l.img; img.alt = ''; img.loading = 'lazy';
          var texto = document.createElement('span');
          texto.textContent = l.nombre + (l.cantidad > 1 ? ' x' + l.cantidad : '');
          var precio = document.createElement('span');
          precio.textContent = self.plata(l.precio * l.cantidad);
          var cambiar = document.createElement('button');
          cambiar.type = 'button';
          cambiar.textContent = 'cambiar';
          cambiar.addEventListener('click', function () { self.abrir(l.paso); });
          li.appendChild(img); li.appendChild(texto); li.appendChild(precio); li.appendChild(cambiar);
          lista.appendChild(li);
        });
      }

      var completo = this.totalTes() >= this.maxTes && !!this.accesorio;
      var normal = this.totalCentavos();
      var final = Math.round(normal * (100 - this.pct) / 100);

      var cifras = this.querySelector('[data-cifras]');
      if (cifras) cifras.hidden = !completo;
      if (completo) {
        this.querySelector('[data-total-normal]').textContent = this.plata(normal);
        this.querySelector('[data-total-final]').textContent = this.plata(final);
        this.querySelector('[data-ahorro]').textContent = 'Ahorras ' + this.plata(normal - final);
      }

      var faltan = this.maxTes - this.totalTes();
      var texto = completo ? 'Tu pack está listo'
        : faltan > 0 ? ('Elige ' + faltan + (faltan === 1 ? ' té más' : ' tés más'))
        : 'Elige tu cuarto producto';
      this.querySelectorAll('[data-falta]').forEach(function (n) { n.textContent = texto; });
      this.querySelectorAll('[data-pagar]').forEach(function (b) { b.disabled = !completo; });

      var anuncio = this.querySelector('[data-anuncio]');
      if (anuncio) {
        anuncio.textContent = completo
          ? ('Pack completo. Total con descuento ' + this.plata(final) + '.')
          : (texto + '.');
      }
    }

    desplazar(flecha) {
      var carro = flecha.closest('.mtt-pick-carrusel').querySelector('[data-carro]');
      var paso = Math.max(carro.clientWidth - 60, 160);
      carro.scrollBy({ left: paso * parseInt(flecha.dataset.flecha, 10), behavior: 'smooth' });
    }

    // Las flechas se apagan en los extremos de cada fila
    sincronizarFlechas() {
      this.querySelectorAll('.mtt-pick-carrusel').forEach(function (c) {
        var carro = c.querySelector('[data-carro]');
        var izq = c.querySelector('[data-flecha="-1"]');
        var der = c.querySelector('[data-flecha="1"]');
        var tope = carro.scrollWidth - carro.clientWidth;
        if (izq) izq.disabled = carro.scrollLeft <= 2;
        if (der) der.disabled = carro.scrollLeft >= tope - 2;
      });
    }

    pagar(boton) {
      var self = this;
      var error = this.querySelector('[data-error]');
      this.querySelectorAll('[data-pagar]').forEach(function (b) { b.disabled = true; });
      boton.textContent = 'Agregando…';
      if (error) { error.hidden = true; error.textContent = ''; }

      var items = this.lineas().map(function (l) {
        return { id: parseInt(l.variante, 10), quantity: l.cantidad };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('carrito');
          return r.json();
        })
        .then(function () {
          self.irA('/checkout');
        })
        .catch(function () {
          self.restaurarBotones();
          if (error) {
            error.hidden = false;
            error.textContent = 'No pudimos agregar el pack. Inténtalo otra vez.';
          }
        });
    }

    // Metodo aparte para poder comprobar el flujo sin salir de la pagina
    irA(url) {
      window.location.href = url;
    }

    cambiarTe(tarjeta, delta) {
      var id = tarjeta.dataset.variant;
      var actual = this.tes.get(id);
      var cantidad = (actual ? actual.cantidad : 0) + delta;
      if (cantidad < 0) return;
      if (delta > 0 && this.totalTes() >= this.maxTes) return;
      if (cantidad === 0) {
        this.tes.delete(id);
      } else {
        this.tes.set(id, {
          cantidad: cantidad,
          nombre: tarjeta.dataset.nombre,
          precio: parseInt(tarjeta.dataset.precio, 10) || 0,
          img: tarjeta.dataset.img
        });
      }
      this.pintar();
      this.avanzar();
    }

    pintar() {
      var self = this;
      var total = this.totalTes();
      var lleno = total >= this.maxTes;

      this.querySelectorAll('[data-te]').forEach(function (tarjeta) {
        var dato = self.tes.get(tarjeta.dataset.variant);
        var cantidad = dato ? dato.cantidad : 0;
        tarjeta.querySelector('[data-cant]').textContent = cantidad;
        tarjeta.querySelector('[data-menos]').disabled = cantidad === 0;
        tarjeta.querySelector('[data-mas]').disabled = lleno;
        if (cantidad > 0) {
          tarjeta.setAttribute('data-elegido', '');
        } else {
          tarjeta.removeAttribute('data-elegido');
        }
      });

      this.querySelectorAll('[data-accesorio]').forEach(function (tarjeta) {
        var elegido = self.accesorio && self.accesorio.tarjeta === tarjeta;
        var boton = tarjeta.querySelector('[data-elegir]');
        var sel = tarjeta.querySelector('[data-variantes]');
        if (elegido) {
          tarjeta.setAttribute('data-elegido', '');
          boton.textContent = 'Elegido';
        } else {
          tarjeta.removeAttribute('data-elegido');
          boton.textContent = 'Elegir';
        }
        if (sel) boton.disabled = !sel.value;
      });

      var estado = this.querySelector('[data-paso="1"] [data-estado]');
      if (estado) estado.textContent = total + ' de ' + this.maxTes;
      var estado2 = this.querySelector('[data-paso="2"] [data-estado]');
      if (estado2) estado2.textContent = this.accesorio ? this.accesorio.nombre : '';

      this.bloqueos();
      this.pintarResumen();
    }
  });
}
